import BranchList from "../../pages/Vfs/VfsBranchList";

export const actionTypes = {
    LOADER: "LOADER",
    BRANCH_LIST : "BRANCH_LIST",
};

const INITIAL_STATE = {
    vfsloader: false,
    BranchList: [],
};

const VfsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.LOADER:
            return {
                ...state,
                vfsloader: action.vfsloader,
            };
        case actionTypes.BRANCH_LIST:
            return {
                ...state,
                BranchList: action.BranchList,
            };

        default:
            return state;
    }
};

export default VfsReducer;
